<script lang="ts">
	import { format } from 'svelte-i18n';
	import {
		ListItem,
		Scroll,
		SidepanelContent,
		Stack,
		SystemStyles,
		Text,
	} from '@Shelly/shelly-design-system/index';
	import { getAddonStatus } from 'src/helpers/addons/addon_helpers';
	import { getLoraAddonStatus } from 'src/helpers/addons/addon_lora_helpers';
	import { getSerialAddonStatus } from 'src/helpers/addons/addon_serial_helpers';
	import { getExtSensorsStatus } from 'src/helpers/ext_sensor_helpers';
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { Device } from 'src/types/Device.ts';

	export let device: Device;

	$: statusStore = getDeviceStatus(device?.id);
	$: deviceOnline = $statusStore?.online;

	let peripherals: Peripheral[] = [];
	let loraPeripherals: Peripheral[] = [];
	$: isGen2Plus = Number(device?.gen) >= 2;
	$: if (deviceOnline) {
		peripherals = isGen2Plus
			? [
					...getAddonStatus(device, [], false, true).filter(
						(item) => item.peripheralType !== 'lora',
					),
					...getSerialAddonStatus(device),
				]
			: getExtSensorsStatus(device);
		loraPeripherals = isGen2Plus ? getLoraAddonStatus(device) : [];
	}
</script>

<SidepanelContent>
	{#if peripherals.length || loraPeripherals.length}
		<div class="mb-m">
			<Text
				element="p"
				styleType="label-large"
				class="mb-s text-uppercase text-color-muted text-center"
			>
				{isGen2Plus
					? $format('settings_title_addon_sensors', {
							default: 'Add-on peripherals',
						})
					: $format('label_external_sensors', {
							default: 'External sensors',
						})}
			</Text>
			<Scroll smallerScroll>
				<Stack gap="xs">
					{#each peripherals as item}
						<ListItem
							class="pointer-events-none"
							fontWeight="solid"
							viewType="fullColored"
							icon={item.icon}
							title={item.sensor.name}
							progress={{
								title: item.value,
							}}
							listItemBgColor={SystemStyles.COLOR_0}
						/>
					{/each}
					{#each loraPeripherals as item}
						<ListItem
							class="pointer-events-none"
							fontWeight="solid"
							viewType="fullColored"
							icon={item.icon}
							title={item.label}
							progress={{
								title: item.value,
							}}
							listItemBgColor={SystemStyles.COLOR_0}
							iconColor={item.iconColor}
						/>
					{/each}
				</Stack>
			</Scroll>
		</div>
	{/if}
</SidepanelContent>
